import React from "react";
import { Provider, connect } from "react-redux";
import { applyMiddleware, compose } from "redux";
import { legacy_createStore as createStore } from 'redux';
import thunk from "redux-thunk";
import reducers from "./reducers";
import ReactDOM from "react-dom/client";
import { getUser } from 'actions';

import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0";
import "./assets/css/pagination.css";
import "./assets/css/demo.css";

import Admin from "layouts/Admin.js";
import LoginForm from "components/LoginForm";
import SetPassword from "views/Auth/SetPassword";

const root = ReactDOM.createRoot(document.getElementById("root"));

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = composeEnhancers(applyMiddleware(thunk))(createStore)(reducers);

window.store = store;

const viewSoldChart = window.location.hostname.includes("resin");

const App = (props) => {
  React.useEffect(() => {
    props.getUser();
  }, []);

  if (!props.user) {
    return <LoginForm />;
  }

  // If user needs to change password, show SetPassword component
  if (props.user.status === 'NEED_CHANGE_PASSWORD') {
    return <SetPassword />;
  }

return (
  <Switch>
    <Route path="/v1" render={(props) => <Admin {...props} />} />
    <Route path="/gpt_images" />
    <Redirect from="/" to="/v1/k3pl-chat" />
</Switch>
);
};

const mapStateToProps = (state) => ({
user: state.authenReducer.user
});

const ConnectedApp = connect(mapStateToProps, { getUser })(App);

root.render(
<Provider store={store}>
  <BrowserRouter>
    <ConnectedApp />
  </BrowserRouter>
</Provider>
);